import { useIsMobile } from "@/lib/hooks/use-mobile";
import { NotificationListDesktop } from "./notification-list-desktop";
import { NotificationListMobile } from "./notification-list-mobile";

interface NotificationListProps {
  className?: string;
  onOpenDialog?: (type: string, id: string, params?: Record<string, any>) => void;
}

export function NotificationList({ className, onOpenDialog }: NotificationListProps) {
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? (
        <NotificationListMobile className={className} onOpenDialog={onOpenDialog} />
      ) : (
        <NotificationListDesktop className={className} onOpenDialog={onOpenDialog} />
      )}
    </>
  );
}

// Legacy export for compatibility - will be removed
export { NotificationActionsMobile as NotificationActions } from "../actions/notification-actions-mobile";
